import * as moment from 'moment';

export class Accountusers {
    lastLogin : moment.Moment;
    created	: moment.Moment;
    updated	: moment.Moment;
    accountId : number;
    userId : number;
}
